<template>
  <div>
    <div class="target-list">
      <div class="title">用户：</div>
      <div class="inner">
        <div
          :style="{
            borderBottom: '1px solid #E9E9E9',
            marginBottom: '10px',
            paddingBottom: '10px'
          }"
        >
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
          >
            全选
          </a-checkbox>
        </div>
        <a-checkbox-group
          class="target-cnt"
          v-model="checkedUserList"
          @change="onChange"
        >
          <a-checkbox
            v-for="item in userOptions"
            :value="item.Id"
            :key="item.Id"
            >{{ item.Value }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </div>
    <div class="sel-target" v-if="selUserList.length">
      <div class="title">已选用户：</div>
      <div class="inner">
        <a-tag
          color="orange"
          v-for="(user, uIndex) in selUserList"
          :key="uIndex"
          :value="user.Id"
          >{{ user.Value }}</a-tag
        >
      </div>
    </div>
    <div class="save-btn">
      <a-button @click="getRemindTarget">取消</a-button>
      <a-button type="primary" @click="onSubmit" class="ml">保存</a-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      checkedUserList: [],
      userOptions: [],
      indeterminate: true,
      checkAll: false
    };
  },
  computed: {
    selUserList() {
      if (this.checkedUserList.length) {
        let list = this.userOptions.filter(el =>
          this.checkedUserList.includes(el.Id)
        );
        return list;
      }
      return [];
    }
  },
  created() {
    this.getUsers();
    this.getRemindTarget();
  },
  methods: {
    getUsers() {
      this.$post("GetRemindUsers").then(res => {
        this.userOptions = res.Data;
      });
    },
    getRemindTarget() {
      this.checkedUserList = [];
      this.$post("GetRemindTarget", { RemindSettingType: 1 }).then(res => {
        if (res.Data.Targets && res.Data.Targets.length) {
          const data = res.Data.Targets.filter(el => el.TargetType != 1);
          if (data && data.length) {
            this.checkedUserList = data.map(v => v.DataId);
          }
        }
      });
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedUserList: e.target.checked
          ? this.userOptions.map(v => v.Id)
          : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
    },
    onChange(checkedList) {
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.userOptions.length;
      this.checkAll = checkedList.length === this.userOptions.length;
    },
    onSubmit() {
      const arr1 = this.selUserList.map(el => {
        return {
          TargetType: 0,
          DataId: el.Id,
          Name: el.Value
        };
      });
      const json = {
        RemindSettingType: 1,
        Targets: [...arr1]
      };
      this.$post("SettingRemindTarget", json).then(() => {
        this.$message.success("设置成功！");
      });
    }
  }
};
</script>

<style lang="less" scoped>
.target-list,
.sel-target {
  width: 1050px;
}
.target-list .target-cnt .ant-checkbox-wrapper,
.target-list .target-cnt .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  padding: 5px;
  background: #f1f1f1;
  border-radius: 3px;
  margin: 3px 8px 0 0;
  display: inline-block;
  width: 132px;
  height: 31px;
  overflow: hidden;
  width: 135px;
}
.target-cnt {
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.sel-target {
  color: #fa8c16;
  max-height: 200px;
  overflow: hidden;
  overflow-y: auto;
  .inner {
    padding: 10px;
    border: 1px solid #eaeaea;
    border-top: 0;
  }
  .ant-tag {
    margin-bottom: 5px;
  }
}
.save-btn {
  margin-top: 10px;
  text-align: center;
}
.target-list .inner {
  padding: 10px;
  border: 1px solid #eaeaea;
  border-top: 0;
}
</style>
